import React from 'react';
import { cx } from '#packages/util';
import { connectWithScope } from '#packages/apilib';
import { withRestrictions } from '#packages/editorRestrictions';
import { mapStateToProps, mapDispatchToProps } from './gapBoxMapper';
import { ResizeGapsScope } from '../resizeGapsScope';
import styles from './gapBox.scss';

import type { GapBoxStateProps, GapBoxDispatchProps } from './gapBoxMapper';

interface GapBoxProps extends GapBoxStateProps, GapBoxDispatchProps {}

const GapBox: React.FC<GapBoxProps> = ({
  currentHeight,
  positionCSS,
  isResizing,
  isVisible,
  startDrag,
  gap,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={positionCSS}
      className={cx(styles.gapBox, {
        [styles.isResizing]: isResizing,
      })}
    >
      <div
        className={styles.resizeHandle}
        onMouseDown={(e) => startDrag(e, gap)}
      />
      {isResizing && (
        <div className={styles.heightIndication}>
          <span>{currentHeight}</span>
        </div>
      )}
    </div>
  );
};

export default withRestrictions('rEditor_hover-gap-box')(
  connectWithScope(
    () => ResizeGapsScope,
    GapBox,
    mapStateToProps,
    mapDispatchToProps,
    {
      rerenderOnMouseOps: true,
    },
  ),
);
